import React from 'react';
import { MainLayout } from '@components';
import SharedDate from './SharedDate';

export default function ShardDataPage(props) {
  return <MainLayout footer="main" children={<SharedDate {...props} />} />;
}
